module.exports = __webpack_public_path__ + "img/Group 463.91daafbe.png";